// newsTimeline.ts
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export class NewsTimeline {
  private timelineLine: HTMLElement | null;
  private newsTimelineItems: NodeListOf<HTMLElement>;
  private newsTimelineBullets: NodeListOf<HTMLElement>;
  private newsTimelineHeadings: NodeListOf<HTMLElement>;
  private newsTimelineList: HTMLOListElement | null;

  constructor(element: HTMLElement) {
    gsap.registerPlugin(ScrollTrigger);

    this.timelineLine = element;

    this.newsTimelineItems = this.timelineLine.querySelectorAll(
      ".news-timeline-item .news-timeline-content"
    );
    this.newsTimelineBullets = this.timelineLine.querySelectorAll(
      ".news-timeline-item .news-timeline-bullet"
    );
    this.newsTimelineHeadings = this.timelineLine.querySelectorAll(
      ".news-timeline-item .news-timeline-heading"
    );
    this.newsTimelineList = this.timelineLine.querySelector(
      ".news-timeline-list"
    );

    this.initAnimations();
    this.initProgressBar();
  }

  private initAnimations(): void {
    // Animate content items from the right side only
    this.newsTimelineItems.forEach((item, index) => {
      gsap.fromTo(
        item,
        {
          opacity: 0,
          x: 100, // Always from right since all items are on right side
        },
        {
          opacity: 1,
          x: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: item,
            start: "top 90%",
            toggleActions: "play none none reverse",
          },
        }
      );
    });

    // Animate bullets - DISABLED (keeping for future use)
    // this.newsTimelineBullets.forEach((item, index) => {
    //     gsap.fromTo(
    //         item,
    //         {
    //             backgroundColor: "#fefefe"
    //         },
    //         {
    //             backgroundColor: "#0087d7",
    //             duration: 0.5,
    //             ease: "power3.out",
    //             scrollTrigger: {
    //                 trigger: item,
    //                 start: "top center",
    //                 toggleActions: "play none none reverse",
    //             },
    //         }
    //     );

    //     gsap.fromTo(item,
    //         {
    //             scale: 1
    //         },
    //         {
    //             scale: 1.5,
    //             duration: 0.2,
    //             yoyo: true,
    //             repeat: 1,
    //             ease: "power1.inOut",
    //             scrollTrigger: {
    //                 trigger: item,
    //                 start: "top center",
    //                 toggleActions: "play none none reverse"
    //             }
    //         }
    //     );
    // });

    // Animate headings - DISABLED (keeping for future use)
    // this.newsTimelineHeadings.forEach((item, index) => {
    //     gsap.fromTo(
    //         item,
    //         {
    //             color: "#fefefe" // white-bold color
    //         },
    //         {
    //             color: "#0087d7",
    //             duration: 0.5,
    //             ease: "power3.out",
    //             scrollTrigger: {
    //                 trigger: item,
    //                 start: "top center",
    //                 toggleActions: "play none none reverse",
    //             },
    //         }
    //     );
    // });
  }

  // Animate vertical progress bar (::before)
  private initProgressBar(): void {
    if (!this.newsTimelineList) return;

    ScrollTrigger.create({
      trigger: this.newsTimelineList,
      start: "top center",
      end: "bottom center",
      scrub: true,
      onUpdate: (self) => {
        const progressPercent = self.progress * 100;
        this.newsTimelineList!.style.setProperty(
          "--progress-height",
          `${progressPercent}%`
        );
      },
    });
  }
}

// document.addEventListener("DOMContentLoaded", () => {
//     new NewsTimeline();
// });

function initTimeline() {
  const timelines = Array.from(
    document.querySelectorAll<HTMLElement>(".blockNewsTimeline")
  );
  if (timelines.length === 0) return;

  const instances: NewsTimeline[] = [];
  for (const el of timelines) {
    const instance = new NewsTimeline(el);

    instances.push(instance);
  }
  (window as any)._timelineInstances = instances;
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTimeline);
} else {
  initTimeline();
}
